import { Box, BoxProps } from "@mui/material";

type DialogComplexFormContainerProps = BoxProps & {};
export const DialogComplexFormContainer = (
  props: DialogComplexFormContainerProps
) => {
  return (
    <Box {...props} sx={{ marginTop: "10px" }}>
      {props.children}
    </Box>
  );
};
